import { Notifier } from '@airbrake/browser'
import { createApp } from 'vue'
import I18NextVue from 'i18next-vue'
import { createPinia } from 'pinia'
import { setAppCallbacks } from './appCallbacks'
import { privacy, dataLayer, configuration, hybrid, setupAirbrake } from '@dpgradio/creative'
import i18next from './i18n'
import { CAMPAIGN_CONFIG, CAMPAIGN_NAME } from './config'
import { useUserStore } from '../store/user'

import '../assets/styles/scoped-themes.scss'

export const initializeApp = async (AppComponent, mountPoint = '#signup-client') => {
  // GET STATION
  await configuration.retrieveConfigForStation(CAMPAIGN_CONFIG.stationId)

  // Set document language from config
  const language = configuration['language']
  if (language) {
    document.documentElement.lang = language
  }

  // PRIVACY
  privacy.initialize()

  // DATALAYER
  dataLayer.initialize()
  dataLayer.setCampaignDetails({
    brand: configuration.stationId,
    signupRequired: true,
    title: CAMPAIGN_CONFIG.title,
    type: 'signup_moment',
  })
  dataLayer.pushVirtualPageView()

  // PINIA
  const pinia = createPinia()

  // APP
  const app = createApp(AppComponent).use(hybrid).use(pinia).use(I18NextVue, { i18next })

  // I18N
  i18next.changeLanguage(CAMPAIGN_NAME)

  // AIRBRAKE
  if (import.meta.env.PROD) {
    const airbrake = await setupAirbrake(
      Notifier,
      {
        projectId: 511287,
        projectKey: '307103f3b4060deeb4f72468775fe766',
        environment: 'production',
      },
      app
    )
    airbrake.addFilter((notice) => {
      notice.context = {
        ...notice.context,
        tokenContext: useUserStore().radioToken ? hybrid.decodeRadioToken(useUserStore().radioToken) : null,
      }
      return notice
    })
  }

  // APP CALLBACKS
  setAppCallbacks()

  app.mount(mountPoint)
}
